import { render } from "./InsuranceCompanyEdit.vue?vue&type=template&id=6ea74546"
import script from "./InsuranceCompanyEdit.vue?vue&type=script&lang=js"
export * from "./InsuranceCompanyEdit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__